module.exports = __webpack_public_path__ + "img/stock5.b0398bd9.png";